/* eslint-disable */

export const dataItem = {
  profileStepper: [
    {
      id: '0',
      title: 'Basic Info',
      key: 'BASIC_INFO'
    },
    {
      id: '1',
      title: 'Contact Info',
      key: 'CONTACT_INFO'
    },
    {
      id: '3',
      title: 'Consent',
      key: 'CONSENT_INFO'
    },
    // {
    //   id: '4',
    //   title: 'Customize',
    //   key: 'CUSTOMIZE_INFO'
    // }
  ],
  profileText: [
    {
      id: 'address1',
      title: 'Address Line 1'
    },
    {
      id: 'name',
      title: 'Full Name'
    },
    {
      id: 'address2',
      title: 'Address Line 2'
    },
    {
      id: 'email',
      title: 'Email'
    },
    {
      id: 'city',
      title: 'City'
    },

    {
      id: 'phone',
      title: 'Phone'
    },
    {
      id: 'state',
      title: 'State'
    }, {
      id: 'zip',
      title: 'ZIP'
    },
  ],
  country: [
    {
      title: 'USA'
    },
    {
      title: 'OTHER'
    },
  ],
  signature: {
    parent: {
      id: 'parent',
      title: 'Parent Name'
    },
  },
  parentConsentField: {
    consentGuardianEmail: {
      id: 'consentGuardianEmail',
      title: 'Parent Email',
      type: 'TEXT-SHORT',
      placement: 'right',
      required: { value: true, err: 'Required' },
      email: { value: true, err: 'Provide a valid email' },
    },
    consentGuardianName: {
      id: 'consentGuardianName',
      title: 'Parent Name',
      type: 'TEXT-SHORT',
      placement: 'right',
      required: { value: true, err: 'Required' },
    }
  },
  yourInfoFields: [
    {
      id: 'dob',
      title: 'Enter your date of birth (MM-DD-YYYY)',
      type: 'DATE',
      required: { value: true, err: 'Enter a valid date' },
      placement: 'left',
    },
    {
      id: 'addressCountryCode',
      title: 'Choose your country',
      type: 'OPTIONS-SELECT',
      required: { value: true, err: 'Required' },
      placement: 'left',
      options: [
        {
          title: 'USA',
          id: 'US'
        },
        {
          title: 'OTHER',
          id: 'OTHER'
        },
      ],
    },
    /*{
      id: 'referralCode',
      title: 'Friend’s Referral Code',
      type: 'TEXT-SHORT',
      required: { value: false, err: 'Required' },
      placement: 'left',
    },*/
  ],//NOTE: order of the below contactInfoFields are important
  contactInfoFields: [
    {
      id: 'givenname',
      title: 'First Name',
      placement: 'left',
      type: 'TEXT-SHORT',
      required: { value: true, err: 'Required' },
    },
    {
      id: 'familyname',
      title: 'Last Name',
      placement: 'right',
      type: 'TEXT-SHORT',
      required: { value: true, err: 'Required' },
    },
    {
      id: 'addressL1',
      title: 'Address Line 1',
      type: 'TEXT-SHORT',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    {
      id: 'addressL2',
      title: 'Address Line 2',
      placement: 'right',
      type: 'TEXT-SHORT',
      required: { value: false, err: 'Required' },
    },
    {
      id: 'addressCity',
      title: 'City',
      placement: 'left',
      type: 'TEXT-SHORT',
      required: { value: true, err: 'Required' },
    },
    {
      id: 'addressState',
      title: 'State',
      type: 'TEXT-SHORT',
      placement: 'right',
      required: { value: true, err: 'Required' },
    },
    {
      id: 'phone',
      title: 'Phone',
      type: 'TEXT-SHORT',
      placement: 'left',
      required: { value: false, err: 'Required' },
      phone: { value: true, err: 'Provide a valid phone number (eg: +1 XXX-XXX-XXXX)' },
    },
    {
      id: 'addressZip',
      title: 'ZIP',
      type: 'TEXT-SHORT',
      placement: 'right',
      required: { value: true, err: 'Required' },
    },
  ],
  consentField: {
    id: 'consent',
    title: 'Description',
    type: 'TEXT-PARA',
    placement: 'left',
    required: { value: false, err: 'Required' },
  },
  referralData: {
    title: 'Tell a Friend or 10',
    desc: 'More data means better data.',
    descExtra: 'Better data means a more meaningful shared resource for all of us. Get 10 friends to complete the survey and we\'ll send you some swag to rep the brand.',
    subDesc: 'NextGen Jane is working to create a first-of-its-kind database of menstrual health. It would not be possible without people like me. And actually, not possible without you either! Join me and take the survey.',
    img: require('../assets/images/referralImg.png')
  },
  surveyCatInfo: {
    essential: {
      title: 'ESSENTIAL',
      catType: 'essential',
      descr: 'Read Me First: The Why, How, and Who of the survey. Get grounded on what we\'re doing and why.\
      \n\nAbout Me: Basic demographic information, including age, ancestry and more.\
      \n\nMenstrual Flow: The heart of the survey, questions about your period and how you manage menstruation.\
      \n\nBirth Control: Questions about the different types of hormonal or non-hormonal birth control methods you either currently use or have previously used.\
      \n\nHealth: Questions to better understand your health background, with a focus on medical history and pelvic health.\
      \n\nCOVID-19: Questions to help us better understand how getting COVID-19 or the COVID-19 vaccine might have impacted your menstrual cycle.\
      \n\nBody: Questions about exercise, sleep, diet, lifestyle and more.\
      \n\nAccess: All about access to doctors, medicine and preventative care.'
    },
    // recommended: {
    //   title: 'RECOMMENDED',
    //   catType: 'recommended',
    //   descr: 'This Mortal Coil: Questions about exercise, sleep, diet, lifestyle and more.\
    //   \n\nMenstrual Experience: How do you manage period pain and how does it impact your behavior?\
    //   \n\nAccess: All about access to doctors, medicine and preventative care.'
    // },
    recommended: {
      title: 'CURRENTLY ENROLLING STUDIES',
      catType: 'recommended',
      descr: 'These sections are for people currently enrolled in and submitting tampon samples for a NextGen Jane Clinical Study. If that\'s not you but you think you qualify for one of these studies and are interested in participating, please email research@nextgenjane.com. \
      \n\nStudy Intake: These are the initial intake questions for people who have been recruited to provide samples for a NextGen Jane clinical study.\
      \n\nPost-Laparoscopy forms: The questions are meant for NextGen Jane study participants to complete at various collection stages following a laparoscopy diagnosing endometriosis.\
      \n\nCycle Form: These questions are to catch the latest and greatest menstrual information for during additional collections.\
      \n\nPregnancy and Loss Form: This form is to be completed by participants when there is a change in pregnancy status.\
      \n\nEndometriosis Recurrence Form: This form is to be completed by participants when there is a change in endometriosis recurrence status.\
      \n\nPost-ART Treatment Form: This form is to be completed by participants after they have completed a round of ART (IUI, IVF, etc).\
      '
    },
    optional: {
      title: 'OPTIONAL',
      catType: 'optional',
      descr: 'Bleeding Disorders: Questions which can help us understand how a bleeding disorder, a condition which affects how your blood normally clots, might be affecting your period.\
      \n\nPregnancy: From fertility to the postpartum experience, your entire pregnancy journey.\
      \n\nEndometriosis, Adenomyosis and Fibroids: For those diagnosed with, or who suspect they have, endometriosis, adenomyosis or fibroids.\
      \n\nAutoimmune Diseases: For those who are diagnosed with, or suspect they have, an autoimmune condition.\
      \n\nLyme Disease: For those who have been diagnosed with Lyme Disease.\
      \n\n(Peri/)Menopause: Questions about your perimenopause or menopause experience.\
      \n\nFor Trans and Gender Non-conforming People: For non-binary or trans people who have felt gender discordance from their gender assigned at birth.\
      \n\nSurvivorship and Assault: This section contains sensitive questions about assault and abuse to better understand the impact assault can have on long term gynecological health outcomes.\
      \n\nMilitary: For current and veteran members of the military.\
      \n\nMental Health: This section contains sensitive questions about mental and emotional health to better understand the impact these factors might have on gynecological health.\
      \n\nDisability (Coming Soon!): We are in the process of developing questions specifically to better understand the unique ways people with a disability navigate gynecological health. If you select this module, we will email you once it is launched.\
      \n\nSexual Dysfunction (Coming Soon!): We are in the process of developing questions to better understand how people with sexual dysfunction navigate gynecological health. If you select this module, we will email you once it is launched.'
    }
  }
}


export const userFields = {
  "fieldDef": {
    "steps": [
      {
        "fields": [
          {
            "key": "internalUser",
            "type": "radio",
            "label": "Internal user?",
            "hint": "Select internal user",
            "options": [
              { key: 'YES', label: 'YES' },
              { key: 'NO', label: 'NO' }
            ],
            "v_required": {
              "value": true,
              "err": "Required"
            },
          }
        ]
      }
    ]
  }
}

export const pSections = {
  "fieldDef": {
    "steps": [
      {
        "fields": [
          {
            "key": "preferedQSections",
            "type": "check_box",
            "label": "Sections",
            "hint": "Select sections",
            "options": [],
            "v_required": {
              "value": true,
              "err": "Select sections"
            },
          }
        ]
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/data/data.js